/**
 * Nextrip¹ — Message wall lightbox + keyboard / swipe
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function initSection(section) {
    if (!section || section.dataset.mwInit === 'true') return;
    section.dataset.mwInit = 'true';

    var lightbox = section.querySelector('[data-n1-mw-lightbox]');
    var img = section.querySelector('[data-n1-mw-lightbox-img]');
    var shots = Array.prototype.slice.call(section.querySelectorAll('[data-n1-mw-shot]'));
    if (!lightbox || !img || !shots.length) return;

    var index = 0;
    var lastFocus = null;
    var touchX = null;

    function openAt(i) {
      if (!shots.length) return;
      index = (i + shots.length) % shots.length;
      var shot = shots[index];
      img.src = shot.getAttribute('data-shot-src') || '';
      img.alt = shot.getAttribute('data-shot-alt') || '';
      lightbox.hidden = false;
      document.documentElement.classList.add('n1-menu-open');
      lastFocus = document.activeElement;
      var closeBtn = lightbox.querySelector('[data-n1-mw-lightbox-close]');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      lightbox.hidden = true;
      img.removeAttribute('src');
      document.documentElement.classList.remove('n1-menu-open');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    shots.forEach(function (shot, i) {
      shot.addEventListener('click', function () {
        openAt(i);
      });
    });

    lightbox.querySelectorAll('[data-n1-mw-lightbox-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    var prev = lightbox.querySelector('[data-n1-mw-lightbox-prev]');
    var next = lightbox.querySelector('[data-n1-mw-lightbox-next]');
    if (prev) prev.addEventListener('click', function () { openAt(index - 1); });
    if (next) next.addEventListener('click', function () { openAt(index + 1); });

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') openAt(index - 1);
      if (e.key === 'ArrowRight') openAt(index + 1);
    });

    lightbox.addEventListener(
      'touchstart',
      function (e) {
        if (!e.changedTouches || !e.changedTouches[0]) return;
        touchX = e.changedTouches[0].clientX;
      },
      { passive: true }
    );

    lightbox.addEventListener(
      'touchend',
      function (e) {
        if (touchX == null || !e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(dx) < 40) return;
        if (dx > 0) openAt(index - 1);
        else openAt(index + 1);
      },
      { passive: true }
    );
  }

  ready(function () {
    document.querySelectorAll('[data-n1-mw]').forEach(initSection);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-n1-mw]') : null;
    if (root) {
      root.dataset.mwInit = '';
      initSection(root);
    }
  });
})();
